"use client";

import React, { FC, memo, useContext, useEffect } from "react";
import classNames from "classnames";
import { ICategoryFeedResponse } from "@finbackoffice/websocket-client";
import { FeedRidContext, useCollapseMargin } from "@finbackoffice/site-core";
import { useDefaultPrematchParamsFromUrl, useSocketStorage } from "hooks";
import { scrollWithOffset } from "utils/helpers";
import CategoryIcon from "components/sport/base/region-icon/CategoryIcon";
import PrematchAllTournamentsContainer from "./tournaments/PrematchAllTournamentsContainer";
import styles from "./prematch-category.module.sass";

interface IProps {
    category: ICategoryFeedResponse;
    openedByDefault: boolean;
    sportSlug: string;
    sportId: number;
    showTournamentCheckbox?: boolean;
    showArrow?: boolean;
}

const PrematchCategory: FC<IProps> = ({
    category,
    openedByDefault,
    sportSlug,
    sportId,
    showTournamentCheckbox = false,
    showArrow = true,
}) => {
    const { prematchRid } = useContext(FeedRidContext);
    const { getTournaments } = useSocketStorage(prematchRid);
    const { opened, animating, headerRef, containerRef } = useCollapseMargin(openedByDefault);
    const { categoryId } = useDefaultPrematchParamsFromUrl();

    useEffect(() => {
        if (category.id === categoryId) {
            void scrollWithOffset(headerRef.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <li className={styles.prematchRegionItem}>
            <div className={classNames(styles.region, opened && styles.opened)} ref={headerRef}>
                <CategoryIcon categoryId={category.id} />
                <span>{category.name}</span>
                <span className={styles.gameCount}>{category.games_count}</span>
                {showArrow && <i className={styles.arrow} />}
            </div>
            {(opened || animating) && (
                <div className={styles.tournamentItemsList}>
                    <div ref={containerRef}>
                        <PrematchAllTournamentsContainer
                            tournaments={getTournaments(category.id)}
                            sportSlug={sportSlug}
                            sportId={sportId}
                            categoryId={category.id}
                            showCheckbox={showTournamentCheckbox}
                        />
                    </div>
                </div>
            )}
        </li>
    );
};

export default memo(PrematchCategory);
